import React from 'react';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components 

import SectionHeader from './formItems/SectionHeader';
import Category from './formItems/Category';
import EmailDescription from './formItems/EmailDescription';
import SubmitButton from './formItems/SubmitButton';

const CreateTicket: React.FC = () => {

  const { t } = useTranslation();
  const accountInfo = useAppSelector((state) => state.meta.accountInfo);
  const isMobile = useMediaQuery('(max-width:600px)');

  return (

    <div style={{ 
        width: '100%',
        height: '100%',
        padding: isMobile ? '2vh 4vw' : '3vh 6vw',
        boxSizing: 'border-box',
        overflowY: 'scroll',
        scrollbarWidth: 'none',
    }}>

      <SectionHeader title={`${t('from')} ${accountInfo.firstName} ${accountInfo.lastName}`} /> 

      <SectionHeader title={t('category')} /> 

      {/* This Box forces the child component to stretch to full width */}
      <Box sx={{ width: '100%', '& > *': { width: '100%' } }}>
        <Category />
      </Box>

      <SectionHeader title={t('description')} /> 

      {/* This Box forces the child component to stretch to full width */}
      <Box sx={{ width: '100%', '& > *': { width: '100%' } }}>
        <EmailDescription />
      </Box>

      <SubmitButton />

    </div>

  );

};

export default CreateTicket;